"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExportErrorFunction = exports.createExportFunction = void 0;
var escapeFileName = function (str) { return str && str.replace(/[/?<>\\:*|":]/g, ""); };
/**
 * Creates function to export data in the provided result. This function is typically passed by visualization
 * components via the onExportReady callback.
 *
 * @param result - data view that will be exported
 * @param exportTitle - optionally specify title
 * @internal
 */
function createExportFunction(result, exportTitle) {
    return function (exportConfig) {
        var format = exportConfig.format, includeFilterContext = exportConfig.includeFilterContext, mergeHeaders = exportConfig.mergeHeaders, customTitle = exportConfig.title;
        var title = escapeFileName(customTitle || exportTitle || "Untitled");
        var exportRequestConfig = {
            format: format,
            mergeHeaders: mergeHeaders,
            title: title,
        };
        if (includeFilterContext) {
            exportRequestConfig.showFilters = true;
        }
        return result.export(exportRequestConfig);
    };
}
exports.createExportFunction = createExportFunction;
/**
 * Creates function that should be passed to onExportReady in the event that the backend execution
 * fails and export is not possible.
 *
 * @param error - the execution error
 * @internal
 */
function createExportErrorFunction(error) {
    return function (_exportConfig) {
        return Promise.reject(error);
    };
}
exports.createExportErrorFunction = createExportErrorFunction;
//# sourceMappingURL=export.js.map